import { HOST } from './../global';

export function buildParams(paramObj: any){
    return Object.keys(paramObj).map((k) => {
        return `${k}=${paramObj[k]}`
    }).join("&")
}

export function globalToLocalURL(url: string){
    return url.replace(HOST, '');
}

export function capitalizeFirstLetter(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}